import {some, map, first, find, groupBy, keys, every, omit, partition, isString} from 'lodash'
import {isSoundItem, isTextItem, isVideoItem, isImageHolderItemWithVideoContent} from '../'
import {
  NO_EFFECT_DEFINITION, GROUP_EFFECT, EXIT_EFFECTS_DEFINITION,
  TEXT_EFFECTS_DEFINITION, HAND_EFFECTS_DEFINITION, ENTER_EFFECTS_DEFINITION,
  DRAW_EFFECTS_DEFINITION, LABELS, ENTER_SAO_EFFECTS, EXIT_SAO_EFFECTS
} from '../consts/enterExitEffects'
import {ENTER_EFFECT_IDS, EXIT_EFFECT_IDS, ENTER_EXIT_EFFECT_IDS} from '../consts'

export const getEffect = (location, selectedTracks) => {
  const effects = map(selectedTracks, track => track[location])
  const group = keys(groupBy(effects, effect => isString(effect) ? effect : effect.effectId))
  const effect = group.length === 1 ?
    find(getEffectLists(selectedTracks)[location], {effectId: first(group)}) :
    GROUP_EFFECT

  return {
    ...(effect || NO_EFFECT_DEFINITION),
    group: group.length > 1,
    handContentId: every(effects, effect => effect.handContentId)
  }
}

const getSAAOEffectsList = (hideDisplayedCategory = false) => {
  const getModifiedEffect = (effect) => hideDisplayedCategory ? omit(effect, 'displayedCategory') : effect
  return {
    enterEffect: ENTER_SAO_EFFECTS.map(getModifiedEffect),
    exitEffect: EXIT_SAO_EFFECTS.map(getModifiedEffect)
  }
}

export const getEffectLists = (tracks = []) => {
  const textTracks = tracks.filter(track => every(track.sprites, isTextItem))
  const [audioTracks, layoutTracks] = partition(tracks, isSoundItem)
  let additionalEffects = []
  if (textTracks.length === tracks.length) {
    additionalEffects = TEXT_EFFECTS_DEFINITION
  }
  else if (textTracks.length === 0) {
    const videoTracks = tracks.filter(track => every(
      track.sprites,
      sprite => isVideoItem(sprite) || isImageHolderItemWithVideoContent(sprite)
    ))
    if (videoTracks.length === 0) {
      additionalEffects = DRAW_EFFECTS_DEFINITION
    }
  }
  const spritesEnabled = layoutTracks.length > 0
  const audioEnabled = audioTracks.length > 0

  return {
    enterEffect: [
      ...(spritesEnabled ? [NO_EFFECT_DEFINITION] : []),
      ...(audioEnabled ? getSAAOEffectsList(!spritesEnabled).enterEffect : []),
      ...(spritesEnabled ? additionalEffects: []),
      ...(spritesEnabled ? ENTER_EFFECTS_DEFINITION: [])
    ],
    exitEffect: [
      ...(spritesEnabled ? [NO_EFFECT_DEFINITION] : []),
      ...(audioEnabled ? getSAAOEffectsList().exitEffect : []),
      ...(spritesEnabled ? EXIT_EFFECTS_DEFINITION : [])
    ]
  }
}

export const getHandEffects = () => HAND_EFFECTS_DEFINITION

export const isTextEffect = effectName => some(TEXT_EFFECTS_DEFINITION, effect => effect.effectId === effectName)
export const isTextHandEffect = ({effectId, handContentId}) => some(TEXT_EFFECTS_DEFINITION,
  (textEffect) => textEffect.effectId === effectId && textEffect.handContentId === handContentId)

export const isDrawEffect = effectName => some(DRAW_EFFECTS_DEFINITION, effect => effect.effectId === effectName)

export const allowHandEffect = effectName => {
  const isNoEffect = effectName === ENTER_EXIT_EFFECT_IDS.NO_EFFECT
  const isFadeEffect = effectName === ENTER_EFFECT_IDS.FADE_IN || effectName === EXIT_EFFECT_IDS.FADE_OUT
  const isRevealEffect = [ENTER_EFFECT_IDS.REVEAL_FROM_LEFT, ENTER_EFFECT_IDS.REVEAL_FROM_BOTTOM,
                          ENTER_EFFECT_IDS.REVEAL_FROM_RIGHT, ENTER_EFFECT_IDS.REVEAL_FROM_TOP,
                          ENTER_EFFECT_IDS.MONTAGE_IN, ENTER_EFFECT_IDS.SMEAR_IN,
                          EXIT_EFFECT_IDS.REVEAL_TO_LEFT, EXIT_EFFECT_IDS.REVEAL_TO_BOTTOM,
                          EXIT_EFFECT_IDS.REVEAL_TO_RIGHT, EXIT_EFFECT_IDS.REVEAL_TO_TOP
  ].findIndex(effect => effect === effectName) >= 0

  return !isNoEffect && !isFadeEffect && !isTextEffect(effectName) && !isRevealEffect && !isDrawEffect(effectName)
}

export const getIsNewEffect = ({label}) => label === LABELS.IS_NEW
export const getIsComingSoonEffect = ({label}) => label === LABELS.COMING_SOON
